import React from 'react';
import { FaCheckCircle, FaFileAlt, FaPhoneAlt, FaWhatsapp, FaHandshake, FaShieldAlt, FaUserMd, FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const ObrasSociales = () => {
  const obrasSocialesPrincipales = [
    {
      nombre: "IOMA",
      cobertura: "100% en prestaciones básicas",
    },
    {
      nombre: "PAMI",
      cobertura: "100% en prestaciones básicas",
    },
    {
      nombre: "OSDE",
      cobertura: "100% en prestaciones básicas",
    },
    {
      nombre: "Swiss Medical",
      cobertura: "100% en prestaciones básicas",
    },
    {
      nombre: "PROFE",
      cobertura: "100% en prestaciones básicas",
    },
    {
      nombre: "Obra Social Ciudad",
      cobertura: "100% en prestaciones básicas",
    }
  ];

  const serviciosCubiertos = [
    "Centro Educativo Terapéutico (CET)",
    "Centro de Día (CD)",
    "Terapias individuales",
    "Transporte especial",
    "Alimentación",
    "Actividades terapéuticas"
  ];

  const documentosNecesarios = [
    {
      documento: "Certificado Único de Discapacidad (CUD)",
      descripcion: "Vigente y con diagnóstico actualizado"
    },
    {
      documento: "Prescripción médica",
      descripcion: "Indicando tipo de prestación (CET o CD) y cantidad de sesiones"
    },
    {
      documento: "DNI del beneficiario",
      descripcion: "Original y copia"
    },
    {
      documento: "Carnet de obra social",
      descripcion: "Vigente del titular y beneficiario"
    },
    {
      documento: "Historia clínica",
      descripcion: "Resumen actualizado del médico tratante"
    },
    {
      documento: "Informes profesionales",
      descripcion: "De terapeutas anteriores si los hubiera"
    }
  ];

  const procesoGestion = [
    {
      paso: "1",
      titulo: "Evaluación inicial",
      descripcion: "Entrevista con nuestro equipo para determinar el servicio adecuado"
    },
    {
      paso: "2",
      titulo: "Recopilación de documentos",
      descripcion: "Nuestro equipo administrativo te ayuda a reunir toda la documentación"
    },
    {
      paso: "3",
      titulo: "Presentación a obra social",
      descripcion: "Gestionamos la autorización ante tu obra social"
    },
    {
      paso: "4",
      titulo: "Inicio del tratamiento",
      descripcion: "Una vez aprobado, comenzamos con el proceso de admisión"
    }
  ];

  return (
    <div className="container">
      {/* Header */}
      <div className="sede-header">
        <h1>Centro de Día y CET</h1>
        <h2>Atención a Obras Sociales en Zona Sur</h2>
        <p>Trabajamos con todas las obras sociales y prepagas. Nuestro equipo gestiona las autorizaciones 
          para que puedas acceder a nuestros servicios de <strong>Centro Educativo Terapéutico</strong> y 
          <strong> Centro de Día</strong> sin complicaciones.</p>
      </div>

      {/* Introducción */}
      <section className="sede-info">
        <div className="sede-details">
          <h2>Cobertura integral para obras sociales</h2>
          <p>
            En <strong>Mi Lugar</strong>, entendemos la importancia del acceso a servicios de calidad para 
            personas con discapacidad. Por eso, trabajamos con todas las obras sociales del país para 
            garantizar que cada familia pueda acceder a nuestros servicios de CET y Centro de Día.
          </p>
          <div className="facilities-grid">
            <div className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>Gestión administrativa sin cargo</h3>
              </div>
            </div>
            <div className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>Asesoramiento para obtener el CUD</h3>
              </div>
            </div>
            <div className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>Seguimiento de autorizaciones</h3>
              </div>
            </div>
            <div className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>Renovaciones automáticas</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Obras Sociales */}
      <section className="sede-facilities">
        <h2 className="section-title">Principales Obras Sociales con las que Trabajamos</h2>
        <div className="facilities-grid">
          {obrasSocialesPrincipales.map((os, index) => (
            <div key={index} className="facility-item">
              <FaShieldAlt className="facility-icon" />
              <div>
                <h3>{os.nombre}</h3>
                <p><strong>Cobertura:</strong> {os.cobertura}</p>
              </div>
            </div>
          ))}
        </div>
        <p>
          * También trabajamos con: OSECAC, OSPACA, OSUTHGRA, OSPACP, OSPEDYC, OSPJN, OSPLAD, OSPATCA, 
          y todas las obras sociales provinciales y prepagas del país.
        </p>
      </section>

      {/* Servicios Cubiertos */}
      <section className="sede-facilities">
        <h2 className="section-title">¿Qué servicios cubren las obras sociales?</h2>
        <div className="sede-info">
          <div className="sede-details">
            <p>
              Las obras sociales brindan cobertura integral para personas con discapacidad según la 
              Ley 24.901. Esto incluye:
            </p>
            <div className="facilities-grid">
              {serviciosCubiertos.map((servicio, index) => (
                <div key={index} className="facility-item">
                  <FaCheckCircle className="facility-icon" />
                  <div>
                    <h3>{servicio}</h3>
                  </div>
                </div>
              ))}
            </div>
            <p>
              <strong>Importante:</strong> La cobertura es del 100% para las prestaciones básicas 
              establecidas por ley, sin costos adicionales para las familias.
            </p>
          </div>
        </div>
      </section>

      {/* Documentación */}
      <section className="sede-facilities">
        <h2 className="section-title">Documentación Necesaria</h2>
        <p>Para iniciar el trámite con tu obra social, necesitarás los siguientes documentos:</p>
        <div className="facilities-grid">
          {documentosNecesarios.map((doc, index) => (
            <div key={index} className="facility-item">
              <FaFileAlt className="facility-icon" />
              <div>
                <h3>{doc.documento}</h3>
                <p>{doc.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Proceso de Gestión */}
      <section className="sede-facilities">
        <h2 className="section-title">¿Cómo gestionamos tu cobertura?</h2>
        <div className="facilities-grid">
          {procesoGestion.map((item, index) => (
            <div key={index} className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>Paso {item.paso}: {item.titulo}</h3>
                <p>{item.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Preguntas Frecuentes */}
      <section className="sede-facilities">
        <h2 className="section-title">Preguntas Frecuentes sobre Obras Sociales</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>¿Qué pasa si no tengo CUD?</h3>
              <p>
                Te orientamos y acompañamos en el proceso para obtener el Certificado Único de Discapacidad. 
                Es un trámite gratuito y fundamental para acceder a los beneficios.
              </p>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>¿Cuánto demora la autorización?</h3>
              <p>
                Generalmente entre 15 y 30 días hábiles, dependiendo de cada obra social. 
                Durante este tiempo, podés conocer nuestras instalaciones y equipo.
              </p>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>¿Qué incluye la cobertura?</h3>
              <p>
                La cobertura incluye todas las prestaciones del Centro de Día o CET: terapias, 
                actividades, alimentación y, en muchos casos, también el transporte.
              </p>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>¿Tengo que pagar algo extra?</h3>
              <p>
                No. Las prestaciones básicas tienen cobertura del 100% por ley. 
                No deberías abonar costos adicionales por los servicios incluidos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default ObrasSociales;
